import s from './RulesPopup.module.css'
import { FC, useContext } from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import InitialStateContext from '../../../context/InitialStateContext'
import { checkCurrencyCode } from '../../../utils/checkCurrencyCode'

const RulesPopup: FC = () => {
    const { t } = useTranslation()
    const [{ currencyCode, limits: { maxBet } }] = useContext(InitialStateContext)

    return (
        <div className={s.popup}>
            <p className={s.title}>{t('GAMEINFO')}</p>
            <p className={s.label}>{t('RULES')}</p>
            <div
                dangerouslySetInnerHTML={{ __html: t('WHEEL_RULES', {
                        currency: checkCurrencyCode(currencyCode),
                        max: String(maxBet)
                    }) }}
            />
        </div>
    )
}

export default RulesPopup
